import Swiper from 'swiper';
import { refs, domReady } from '../modules/utils.js';

class FeatureSlider extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#slider();
    this.#listeners();
  }

  #listeners() {
    this.refs.next?.addEventListener('click', (e) => {
      if (this.slider) {
        this.slider.slideNext();
      }
    });

    this.refs.prev?.addEventListener('click', (e) => {
      if (this.slider) {
        this.slider.slidePrev();
      }
    });
  }

  #slider() {
    if (!this.refs.slider) return;
    const slidesCount = this.refs.slides?.length ?? 0;
    if (slidesCount < 1) return;

    this.slider = new Swiper(
      this.refs.slider,
      {
        slidesPerView: 2,
        spaceBetween: 0,
        loop: slidesCount > 3,
        loopAdditionalSlides: 1
        // modules: [Autoplay],
        // autoplay: {
        //   delay: 10000,
        //   disableOnInteraction: false,
        //   pauseOnMouseEnter: false
        // }
      }
    );

    this.slider.on('slideChange', () => {
      this.dataset.index = this.slider.realIndex;
    });
  }
}

customElements.define('feature-slider', FeatureSlider);
